import React, { FC } from 'react';
import classNames from 'classnames';
import { t, useModal } from '@whitesharx/starfall-frontend-core';
import { Image, sounds } from '@whitesharx/starfall-frontend-ui-kit';
import GameArchiveModal from '../GameArchiveModal';
import { containerStyles, imageStyles, textStyles } from './styles.css';

type Props = {
  className?: string;
};

const GameArchiveButton: FC<Props> = ({ className }) => {
  const { isOpen, close, open } = useModal();

  const handleClick = () => {
    sounds.play('click');
    open();
  };

  return (
    <>
      <button className={classNames(containerStyles, className)} onClick={handleClick}>
        <Image className={imageStyles} src="assets/images/archive.webp" />
        <span className={textStyles}>{t('game-archive.title')}</span>
      </button>
      {isOpen && <GameArchiveModal onRequestClose={close} />}
    </>
  );
};

export default GameArchiveButton;
